// Narrower than the server's pattern on purpose: a name it refuses counts as a failed attempt
const labelPattern = /^[0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ]([0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ '-]{0,43}[0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ])$/;

const secondFactorLabelOk = (label) => labelPattern.test(label);

export default secondFactorLabelOk;
